export const CHECKOUT_URL = 'https://speech-therapy-pro.impultienda.ar/checkout'
export const OFFER_ANCHOR = '#offer'
export const PRODUCT_NAME = 'SPEECH THERAPY PRO™'
export const PRODUCT_IMG =
  'https://cdn.magicpatterns.com/uploads/j9XU27VuTP3zXUHutnbWT6/ChatGPT_Image_4_ago_2026,_03_23_56_p.m..png'
